<caroo-resource [resource]="resource" [fallback]="fallback"></caroo-resource>
